/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ExamUpdateEditorViewModel } from "../types/ExamUpdateEditorViewModel.ts";

export const examUpdateEditorViewModelSchema = z.object({
  title: z.string().nullish(),
  disciplineId: z.number().int().nullish(),
  randomize: z.optional(z.boolean()),
  questionsQuantity: z.number().int().nullish(),
  gradeCriteria: z.optional(z.number().int()),
  examType: z.optional(z.number().int()),
  examReferenceShow: z.optional(z.number().int()),
  examReferenceShowPost: z.optional(z.number().int()),
  showAnswersTries: z.optional(z.boolean()),
  weight: z.optional(z.number().int()),
  percentualComplexity: z.optional(z.number().int()),
  companyId: z.number().int().nullish(),
  recommendedToDoOnPortal: z.optional(z.boolean()),
  enableBlockUnauthorizedActions: z.optional(z.boolean()),
  enableSafeEvaluationMode: z.optional(z.boolean()),
  maxScreenExitsAllowed: z.number().int().nullish(),
}) as unknown as ToZod<ExamUpdateEditorViewModel>;
